export const MUTATION_KEYS = {
  DISCONNECT_GIT_PROVIDER: 'disconnectGitProvider',
  INVITE_TEAM_MEMBERS: 'inviteTeamMembers',
  INVITE_ORGANIZATION_MEMBERS: 'inviteOrganizationMembers',
  CREATE_CUSTOMER_PORTAL_SESSION: 'createCustomerPortalSession',
  CREATE_ORG_CUSTOMER_PORTAL_SESSION: 'createOrgCustomerPortalSession',
  CREATE_CHECKOUT_SESSION: 'createCheckoutSession',
  CREATE_BILLING_CHECKOUT_SESSION: 'createBillingCheckoutSession',
  MIGRATE_CONVERSION: 'migrateConversion',
  REVERSE_MOVE: 'reverseMove',
  CREATE_BILLING_PORTAL_SESSION: 'createBillingPortalSession',
  CANCEL_SUBSCRIPTION: 'cancelSubscription',
  REACTIVATE_SUBSCRIPTION: 'reactivateSubscription',
  CHANGE_PLAN: 'changePlan',
  CANCEL_SCHEDULED_CHANGE: 'cancelScheduledChange',
  UPDATE_BILLING_INFO: 'updateBillingInfo',
  UPDATE_USER: 'updateUser',
  DELETE_MEMBER: 'deleteMember',
  DELETE_INVITE: 'deleteInvite',
  DELETE_TEAM_MEMBER: 'deleteTeamMember',
  DELETE_TEAM_INVITE: 'deleteTeamInvite',
  DELETE_SELF: 'deleteSelf',
  RESPOND_TO_ACCESS_REQUESTS: 'respondToAccessRequests',
  CREATE_API_KEY: 'createApiKey',
  DELETE_API_KEY: 'deleteApiKey',
  DELETE_TEAM: 'deleteTeam',
  CREATE_ORGANIZATION_TEAM: 'createOrganizationTeam',
  UPDATE_ORGANIZATION_TEAM: 'updateOrganizationTeam',
  UPDATE_ORGANIZATION: 'updateOrganization',
  DELETE_RULE: 'deleteRule',
  DELETE_GIT_INSTALLATION: 'deleteGitInstallation',
  SYNC_GIT_INSTALLATION: 'syncGitInstallation',
  SYNC_AZURE_REPOSITORIES: 'syncAzureRepositories',
  START_MASTER_APP_CONSENT: 'startMasterAppConsent',
  ADD_SERVICE_PRINCIPAL_TO_DEVOPS: 'addServicePrincipalToDevOps',
  RESPOND_TO_INVITE: 'respondToInvite',
  INITIATE_MT_GITHUB_INSTALLATION: 'initiateMTGithubInstallation',
  CREATE_MT_MARKETPLACE_INSTALLATION: 'createMTMarketplaceInstallation',
  BITBUCKET_OAUTH_SESSION_CREATE: 'bitbucketOAuthSessionCreate',
  BITBUCKET_CREATE_INSTALLATION: 'bitbucketCreateInstallation',
  BITBUCKET_INSTALL_WEBHOOKS: 'bitbucketInstallWebhooks',
  BITBUCKET_REINSTALL_WEBHOOKS: 'bitbucketReinstallWebhooks',
  GERRIT_CREATE_INSTALLATION: 'gerritCreateInstallation',
  CONFIGURE_GITLAB: 'configureGitlab',
  CONFIGURE_GITLAB_MULTI: 'configureGitlabMulti',
  PROVISION_GITLAB_GROUPS: 'provisionGitlabGroups',
  PROVISION_GITLAB_GROUP_TOKEN: 'provisionGitlabGroupToken',
  PROVISION_GITLAB_TOKEN: 'provisionGitlabToken',
  GITLAB_PROVISIONING_CONNECT: 'gitlabProvisioningConnect',
  GITLAB_PROVISION: 'gitlabProvision',
  GITLAB_INSTALL: 'gitlabInstall',
  GITLAB_UNINSTALL: 'gitlabUninstall',
  GITLAB_MANAGE: 'gitlabManage',
  LOGIN_GITLAB: 'loginGitlab',
  LOGIN_GITLAB_MT: 'loginGitlabMT',
  LOGIN_GITLAB_RETRY: 'loginGitlabRetry',
  INSTALL_GITLAB_WEBHOOKS: 'installGitlabWebhooks',
  INSTALL_GITLAB_WEBHOOKS_BY_GROUPS: 'installGitlabWebhooksByGroups',
  INSTALL_ALL_GITLAB_WEBHOOKS: 'installAllGitlabWebhooks',
  ADD_INSTALLATION_REPOSITORIES: 'addInstallationRepositories',
  REMOVE_INSTALLATION_REPOSITORIES: 'removeInstallationRepositories',
  UPDATE_REPOSITORY_CAPABILITIES: 'updateRepositoryCapabilities',
  DISCONNECT_INTEGRATION: 'disconnectIntegration',
  CREATE_PERSONA_PROMPT: 'createPersonaPrompt',
  ROLLBACK_PERSONA: 'rollbackPersona',
  UPDATE_PERSONAS_CONFIG: 'updatePersonasConfig',
  TRIGGER_PERSONAS_REFRESH: 'triggerPersonasRefresh',
  BOOTSTRAP_PERSONAS: 'bootstrapPersonas',
  CONNECT_SERVICENOW: 'connectServiceNow',
  BULK_UPSERT_CROSS_REPO_EDGES: 'bulkUpsertCrossRepoEdges',
  DELETE_CROSS_REPO_EDGE: 'deleteCrossRepoEdge',
  TRIGGER_CROSS_REPO_DISCOVERY: 'triggerCrossRepoDiscovery',
  TRIGGER_REPOSITORY_INDEX: 'triggerRepositoryIndex',
  CONFIRM_DEVICE_CODE: 'confirmDeviceCode',
  ADOPT_DEVICE_CODE: 'adoptDeviceCode',
  SAVE_SANDBOX_CONFIG: 'saveSandboxConfig',
  DELETE_SANDBOX_CONFIG: 'deleteSandboxConfig',
  DISMISS_FINDING: 'dismissFinding',
};

export const CSV_SPECIFIC_ERROR_REGEXP = /^400:\s*(CSV[\s\S]*)$/i;
